import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { StationForm } from "../../components/StationForm";
import { createStation } from "../../api/station";
import type { StationFormData } from "../../schemas/station";
import { useCopyContext } from "../../context/CopyContext";
import { toast } from "react-toastify";

export function AddStation() {
  const navigate = useNavigate();
  const { copiedStation } = useCopyContext();
  const mutation = useMutation({
    mutationFn: createStation,
    onSuccess: () => {
      setTimeout(() => {
        navigate("/admin/dashboard");
      }, 1000);
    },
    onError: (error) => {
      if (
        error.message ===
        "A station with this name and connector ID already exists"
      ) {
        toast.error("A station with this name and connector ID already exists");
      }
    },
  });

  const handleSubmit = async (data: StationFormData) => {
    mutation.mutate(data);
  };

  console.log(copiedStation);
  return (
    <div className="min-h-screen w-full bg-gray-50">
      <div className="min-h-screen w-full flex items-start pt-8 justify-center p-4">
        <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">
            Add New Station
          </h2>
          <StationForm
            onSubmit={handleSubmit}
            initialData={copiedStation}
            isLoading={mutation.isPending}
            isSuccess={mutation.isSuccess}
            isAddNew={true}
          />
        </div>
      </div>
    </div>
  );
}
